import './styles.scss';

const GradientText = ({ children, size = 'big' }) => (
    <div className={`gradient-text gradient-text--${size}`}>{children}</div>
);

export default GradientText;
